import Consts from 'Framework/Consts';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const MasooliatMadaniHttpConfig = createAxiosHttpConfig({
  baseURL: Consts.env.REACT_APP_MASOOLIAT_MADANI_APP_BASE_URL,
});

export const MasooliatMadaniHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: MasooliatMadaniHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const MasooliatMadaniHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: MasooliatMadaniHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });

export default MasooliatMadaniHttpConfig;
